import { render, staticRenderFns } from "./suDetail.vue?vue&type=template&id=47c04ccc"
import script from "./suDetail.vue?vue&type=script&lang=js"
export * from "./suDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports